export const WALLET_BALANCES_REFETCH_INTERVAL = 3000

export const SLIPPAGE = 0.05 // 5%
